<div class="pathway-header" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>

    <qai-alert *ngIf="!loading && isEnrollmentCompleted" [kind]="'success'" [title]="'learningPathway.PATHWAY_COMPLETED_TITLE' | transloco" class="alert-spacing">
      {{ 'learningPathway.PATHWAY_COMPLETED_BODY' | transloco }}
      <div class="alert-action">
        <button qai-button kind="tertiary-text" size="small" (click)="goToLearnerDashboard()">{{ 'learningPathway.PATHWAY_COMPLETED_RETURN' | transloco }}</button>
      </div>
    </qai-alert>

    <qai-alert *ngIf="!loading && hasStepOutOfAttempts" [kind]="'error'" [title]="'learningPathway.PATHWAY_OUT_OF_ATTEMPTS_TITLE' | transloco" class="alert-spacing">
      {{ 'learningPathway.PATHWAY_OUT_OF_ATTEMPTS_BODY' | transloco }}
    </qai-alert>

    <!-- Step Flow - Only show when not loading and steps are available -->
    <qai-step-flow
      *ngIf="!loading && pathwaySteps.length > 0"
      (allStepsComplete)="onAllStepsComplete()"
    >
      @for (step of pathwaySteps; track step.stepUuid) {
        <qai-step-card
          [title]="step.title"
          [description]="step.description"
          [ctaLabel]="step.ctaLabel"
          [ctaTooltipText]="step.ctaTooltipText"
          [state]="step.state"
          (ctaClick)="step.ctaLabel ? onStepClick(step) : null"
          [ctaButtonVisible]="step.stepType !== PathwayStepType.QUIZ && !!step.ctaLabel"
          [showHeader]="step.stepType !== PathwayStepType.QUIZ"

        >
          @if (step.stepType === PathwayStepType.QUIZ) {
            <qai-quiz
              [title]="step.title"
              [disabled]="step.state === 'disabled'"
              [isComplete]="step.state === 'completed'"
              [attemptsRemaining]="step.attemptsRemaining"
              [instructionText]="step.description"
              [attempts]="getSortedQuizAttempts(step)"
              [overallScoreTooltip]="getOverallScoreTooltip()"
              [columnHeaders]="getQuizColumnHeaders()"
              [showAllAttemptsLink]="(step.quizAttempts?.length ?? 0) >= 1"
              (beginClick)="onStepClick(step)"
              (reattemptClick)="onStepClick(step)"
              (viewFeedbackClick)="onViewFeedbackClick($event)"
              (viewAllAttemptsClick)="onViewAllAttemptsClick(step)"
            />
          }
        </qai-step-card>
      }
    </qai-step-flow>
  </qai-inner-wrap>
</div>
